import type { BlokProps } from "@trydig/storyblok";
import type { BlokTestimonial } from "@/storyblok";
import { AssetBlok, multiAssetToSingleAsset, sizes } from "../Asset";
import BlokWrap from "../BlokWrap";
import styles from "./TestimonialBlok.module.css";

export const TestimonialBlok = ({ blok }: BlokProps<BlokTestimonial>) => {
	return (
		<BlokWrap editable={blok} asChild>
			<div className={styles.root}>
				<div className={styles.image}>
					<AssetBlok
						source={multiAssetToSingleAsset(blok.image!)}
						muted
						autoPlay
						loop
						priority
						quality={90}
						sizes={sizes(100, 100)}
					/>
				</div>
				<div className={styles.content}>
					<span data-viewport="desktop" className={styles.text}>
						{blok.text}
					</span>
					<span data-viewport="mobile" className={styles.text}>
						{blok.mobileText || blok.text}
					</span>
					<span className={styles.author}>{blok.author}</span>
				</div>
			</div>
		</BlokWrap>
	);
};
